import React, { Component } from 'react'
import { observer } from 'mobx-react'
import ButtonsRow from '@ui/ButtonsRow'

@observer
export default class Rating extends Component {
  render() {
    const { buttons, onChange, selected, inactive, mode, children } = this.props

    return (
      <div className='flex vertical'>
        <ButtonsRow
          buttons={buttons}
          onSelect={onChange}
          selected={selected}
          inactive={inactive}
          mode={mode}
        />
        {children}
      </div>
    )
  }
}
